import { navLinks } from "@/mocks/gossipData";

export default function Footer() {
  const go = (id: string) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer className="mt-10 bg-paper-200 text-ink-700">
      <div className="mx-auto max-w-[1360px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-[1.4fr_0.8fr_0.8fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-sign-500 text-paper-50">
                <i className="ri-focus-3-line text-xl" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-black text-ink-900">真瓜研究所</span>
                <span className="mt-1 text-[11px] tracking-[0.2em] text-ink-500">CHIGUA·LAB</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-ink-600">
              吃瓜八卦推理与分析的爱好者的聚集地。从吃瓜八卦细节到吃瓜八卦显微镜，循着蛛丝马迹理出逻辑链——
              理性吃瓜，讲究证据。
            </p>
            <div className="mt-5 flex gap-2.5">
              {[
                "ri-weibo-line",
                "ri-wechat-2-line",
                "ri-message-3-line",
                "ri-earth-line",
                "ri-rss-line",
              ].map((ic) => (
                <a
                  key={ic}
                  href="#subscribe"
                  onClick={(e) => {
                    e.preventDefault();
                    go("subscribe");
                  }}
                  aria-label="真瓜研究所社交媒体"
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-ink-800/15 text-ink-600 transition-colors hover:border-sign-400 hover:bg-sign-500 hover:text-paper-50"
                >
                  <i className={ic} />
                </a>
              ))}
            </div>
          </div>

          <nav>
            <h3 className="font-heading text-sm font-bold text-ink-900">内容栏目</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      go(l.id);
                    }}
                    className="text-ink-600 transition-colors hover:text-sign-700"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-heading text-sm font-bold text-ink-900">工法速览</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-ink-600">
              {["吃瓜八卦推理", "吃瓜八卦分析", "吃瓜八卦显微镜", "吃瓜八卦逻辑链", "吃瓜八卦细节"].map(
                (t) => (
                  <li key={t}>
                    <a
                      href="#method"
                      onClick={(e) => {
                        e.preventDefault();
                        go("method");
                      }}
                      className="transition-colors hover:text-sign-700"
                    >
                      {t}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-ink-900">联系我们</h3>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-ink-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-sign-600" />
                <span>编辑部：press@chigua-lab.example</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-message-2-line mt-0.5 text-sign-600" />
                <span>瓜友投稿：readers@chigua-lab.example</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-sign-600" />
                <span>答疑时间：每天 10:00 - 20:00</span>
              </li>
            </ul>
            <button
              type="button"
              onClick={() => document.getElementById("class")?.scrollIntoView({ behavior: "smooth" })}
              className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-ink-800/20 px-4 py-2 text-sm font-semibold text-ink-700 transition-colors hover:border-sign-400 hover:text-sign-700"
            >
              <i className="ri-book-open-line" />
              从这里开始学吃瓜
            </button>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-ink-800/10 pt-5 sm:flex-row">
          <p className="text-xs text-ink-500">
            © {new Date().getFullYear()} 真瓜研究所 Chigua Lab · 理性围观，快乐吃瓜
          </p>
          <div className="flex items-center gap-4 text-xs text-ink-500">
            <a
              href="#about"
              onClick={(e) => {
                e.preventDefault();
                go("about");
              }}
              className="hover:text-sign-700"
            >
              内容原则
            </a>
            <a
              href="#faq"
              onClick={(e) => {
                e.preventDefault();
                go("faq");
              }}
              className="hover:text-sign-700"
            >
              常见问题
            </a>
            <button
              type="button"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="flex items-center gap-1.5 whitespace-nowrap text-ink-600 hover:text-sign-700"
            >
              回到顶部 <i className="ri-arrow-up-line" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}